export const DEFAULT_CHART_OPTIONS = {
  chartStyle: 'default',
};

export const CHART_STYLE_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'monochrome', label: 'Monochrome' },
  { value: 'enhancedContrast', label: 'Enhanced Contrast' },
  { value: 'highContrast', label: 'High Contrast' },
  { value: 'defaultDark', label: 'Default (Dark)' },
  { value: 'voyager', label: 'Voyager' },
  { value: 'voyagerDark', label: 'Voyager (Dark)' },
  { value: 'dark', label: 'Dark' },
];

const CHART_THEME_CONFIG = {
  default: {
    chartStyle: 'default',
    darkMode: false,
    containerClassName: undefined,
    panelBackground: '#ffffff',
    plotBackground: '#ffffff',
    textColor: '#111827',
    mutedTextColor: '#4b5563',
    axisColor: '#9ca3af',
    gridColor: '#e5e7eb',
    tooltipBackground: 'rgba(255, 255, 255, 0.94)',
    tooltipBorderColor: '#111827',
    dataZoomBackground: 'rgba(229, 231, 235, 0.55)',
    dataZoomFiller: 'rgba(67, 108, 154, 0.28)',
    dataZoomHandle: '#436c9a',
    iconColor: '#111827',
    neutralBarColor: '#add8e6',
    seriesPalette: ['#2563eb', '#dc2626', '#15803d', '#a16207', '#7e22ce', '#0f766e'],
  },
  monochrome: {
    chartStyle: 'monochrome',
    darkMode: true,
    monochrome: true,
    containerClassName: 'fusion-chart-dark-ui fusion-chart-monochrome-ui',
    panelBackground: '#111111',
    plotBackground: '#050505',
    textColor: '#ffffff',
    mutedTextColor: 'rgba(255, 255, 255, 0.74)',
    axisColor: 'rgba(255, 255, 255, 0.46)',
    gridColor: 'rgba(255, 255, 255, 0.16)',
    tooltipBackground: 'rgba(17, 17, 17, 0.96)',
    tooltipBorderColor: 'rgba(255, 255, 255, 0.34)',
    dataZoomBackground: 'rgba(255, 255, 255, 0.12)',
    dataZoomFiller: 'rgba(255, 255, 255, 0.24)',
    dataZoomHandle: '#d4d4d4',
    iconColor: '#ffffff',
    neutralBarColor: '#bdbdbd',
    seriesPalette: ['#f5f5f5', '#d4d4d4', '#a3a3a3', '#737373', '#e5e5e5', '#bdbdbd'],
  },
  enhancedContrast: {
    chartStyle: 'enhancedContrast',
    darkMode: true,
    containerClassName: 'fusion-chart-dark-ui fusion-chart-enhanced-contrast-ui',
    panelBackground: '#111827',
    plotBackground: '#0b1220',
    textColor: '#f8fafc',
    mutedTextColor: '#dbeafe',
    axisColor: '#93a4b8',
    gridColor: 'rgba(219, 234, 254, 0.18)',
    tooltipBackground: 'rgba(17, 24, 39, 0.97)',
    tooltipBorderColor: '#93a4b8',
    dataZoomBackground: 'rgba(219, 234, 254, 0.12)',
    dataZoomFiller: 'rgba(96, 165, 250, 0.35)',
    dataZoomHandle: '#bfdbfe',
    iconColor: '#f8fafc',
    neutralBarColor: '#7dd3fc',
    seriesPalette: ['#60a5fa', '#f87171', '#34d399', '#fbbf24', '#c084fc', '#2dd4bf'],
  },
  highContrast: {
    chartStyle: 'highContrast',
    darkMode: true,
    preserveAccessibleSeriesColors: true,
    containerClassName: 'fusion-chart-dark-ui fusion-chart-high-contrast-ui',
    panelBackground: '#000000',
    plotBackground: '#000000',
    textColor: '#ffffff',
    mutedTextColor: '#ffffff',
    axisColor: '#ffffff',
    gridColor: 'rgba(255, 255, 255, 0.42)',
    tooltipBackground: '#000000',
    tooltipBorderColor: '#ffffff',
    dataZoomBackground: 'rgba(255, 255, 255, 0.18)',
    dataZoomFiller: 'rgba(255, 255, 0, 0.38)',
    dataZoomHandle: '#ffff00',
    iconColor: '#ffffff',
    neutralBarColor: '#00ffff',
    seriesPalette: ['#ffff00', '#00ffff', '#ffffff', '#ff00ff', '#00ff00', '#ff9900'],
  },
  voyager: {
    chartStyle: 'voyager',
    darkMode: false,
    containerClassName: 'fusion-chart-voyager-ui',
    panelBackground: '#f7f3ea',
    plotBackground: '#fbf8f0',
    textColor: '#1f2933',
    mutedTextColor: '#52616d',
    axisColor: '#9d8f76',
    gridColor: 'rgba(118, 107, 88, 0.28)',
    tooltipBackground: 'rgba(251, 248, 240, 0.96)',
    tooltipBorderColor: '#9d8f76',
    dataZoomBackground: 'rgba(157, 143, 118, 0.18)',
    dataZoomFiller: 'rgba(67, 108, 154, 0.25)',
    dataZoomHandle: '#436c9a',
    iconColor: '#1f2933',
    neutralBarColor: '#79b8cf',
    seriesPalette: ['#336b87', '#b34f45', '#3f7d58', '#9a6b22', '#76528b', '#317873'],
  },
  voyagerDark: {
    chartStyle: 'voyagerDark',
    darkMode: true,
    containerClassName: 'fusion-chart-dark-ui fusion-chart-voyager-dark-ui',
    panelBackground: '#17283b',
    plotBackground: '#102033',
    textColor: '#f8fbff',
    mutedTextColor: 'rgba(248, 251, 255, 0.72)',
    axisColor: 'rgba(248, 251, 255, 0.42)',
    gridColor: 'rgba(248, 251, 255, 0.14)',
    tooltipBackground: 'rgba(50, 82, 119, 0.96)',
    tooltipBorderColor: 'rgba(255, 255, 255, 0.26)',
    dataZoomBackground: 'rgba(248, 251, 255, 0.12)',
    dataZoomFiller: 'rgba(99, 161, 224, 0.32)',
    dataZoomHandle: '#8fc2ff',
    iconColor: '#f8fbff',
    neutralBarColor: '#67c7e5',
    seriesPalette: ['#67aee8', '#e87979', '#65b982', '#d7b45a', '#b99adc', '#62b8b0'],
  },
  defaultDark: {
    chartStyle: 'defaultDark',
    darkMode: true,
    containerClassName: 'fusion-chart-dark-ui fusion-chart-voyager-dark-ui',
    panelBackground: '#17283b',
    plotBackground: '#102033',
    textColor: '#f8fbff',
    mutedTextColor: 'rgba(248, 251, 255, 0.72)',
    axisColor: 'rgba(248, 251, 255, 0.42)',
    gridColor: 'rgba(248, 251, 255, 0.14)',
    tooltipBackground: 'rgba(50, 82, 119, 0.96)',
    tooltipBorderColor: 'rgba(255, 255, 255, 0.26)',
    dataZoomBackground: 'rgba(248, 251, 255, 0.12)',
    dataZoomFiller: 'rgba(99, 161, 224, 0.32)',
    dataZoomHandle: '#8fc2ff',
    iconColor: '#f8fbff',
    neutralBarColor: '#67c7e5',
    seriesPalette: ['#67aee8', '#e87979', '#65b982', '#d7b45a', '#b99adc', '#62b8b0'],
  },
  dark: {
    chartStyle: 'dark',
    darkMode: true,
    containerClassName: 'fusion-chart-dark-ui',
    panelBackground: '#0b1118',
    plotBackground: '#070b10',
    textColor: '#f9fafb',
    mutedTextColor: 'rgba(249, 250, 251, 0.72)',
    axisColor: 'rgba(249, 250, 251, 0.36)',
    gridColor: 'rgba(249, 250, 251, 0.12)',
    tooltipBackground: 'rgba(17, 24, 39, 0.96)',
    tooltipBorderColor: 'rgba(255, 255, 255, 0.22)',
    dataZoomBackground: 'rgba(249, 250, 251, 0.1)',
    dataZoomFiller: 'rgba(99, 161, 224, 0.28)',
    dataZoomHandle: '#d1d5db',
    iconColor: '#f9fafb',
    neutralBarColor: '#60a5fa',
    seriesPalette: ['#60a5fa', '#f87171', '#4ade80', '#facc15', '#c084fc', '#5eead4'],
  },
};

export const normalizeChartOptions = (chartOptions = DEFAULT_CHART_OPTIONS) => {
  if (!chartOptions || typeof chartOptions !== 'object') {
    return { ...DEFAULT_CHART_OPTIONS };
  }

  const chartStyle = CHART_THEME_CONFIG[chartOptions.chartStyle]
    ? chartOptions.chartStyle
    : DEFAULT_CHART_OPTIONS.chartStyle;

  return {
    ...DEFAULT_CHART_OPTIONS,
    chartStyle,
  };
};

export const getChartThemeConfig = (chartOptions = DEFAULT_CHART_OPTIONS) => {
  const normalized = normalizeChartOptions(chartOptions);
  return CHART_THEME_CONFIG[normalized.chartStyle] || CHART_THEME_CONFIG.default;
};

const styleAxis = (axis, theme) => ({
  ...axis,
  axisLabel: {
    ...axis?.axisLabel,
    color: theme.textColor,
  },
  nameTextStyle: {
    ...axis?.nameTextStyle,
    color: theme.mutedTextColor,
  },
  axisLine: {
    ...axis?.axisLine,
    lineStyle: {
      ...axis?.axisLine?.lineStyle,
      color: theme.axisColor,
    },
  },
  splitLine: {
    ...axis?.splitLine,
    lineStyle: {
      ...axis?.splitLine?.lineStyle,
      color: theme.gridColor,
    },
  },
});

const mapAxis = (axis, theme) => {
  if (Array.isArray(axis)) {
    return axis.map((item) => styleAxis(item, theme));
  }
  if (!axis) return axis;
  return styleAxis(axis, theme);
};

const styleDataZoom = (zoom, theme) => ({
  ...zoom,
  textStyle: {
    ...zoom?.textStyle,
    color: theme.mutedTextColor,
  },
  borderColor: theme.axisColor,
  fillerColor: theme.dataZoomFiller,
  backgroundColor: theme.dataZoomBackground,
  handleStyle: {
    ...zoom?.handleStyle,
    color: theme.dataZoomHandle,
    borderColor: theme.dataZoomHandle,
  },
});

const mapStyleObject = (value, styler) => {
  if (Array.isArray(value)) {
    return value.map((item) => styler(item));
  }
  if (!value) return value;
  return styler(value);
};

const recolorSvgSymbol = (symbol, color) => {
  const prefix = 'image://data:image/svg+xml,';
  if (typeof symbol !== 'string' || !symbol.startsWith(prefix)) return symbol;

  try {
    const svg = decodeURIComponent(symbol.slice(prefix.length))
      .replace(/(["':;\s])black(?=["';\s/>])/gi, `$1${color}`)
      .replace(/(["':;\s])#000(?:000)?(?=["';\s/>])/gi, `$1${color}`);
    return `${prefix}${encodeURIComponent(svg)}`;
  } catch {
    return symbol;
  }
};

const styleMarkPoint = (markPoint, theme) => {
  if (!markPoint?.data) return markPoint;

  return {
    ...markPoint,
    data: markPoint.data.map((point) => ({
      ...point,
      symbol: recolorSvgSymbol(point.symbol, theme.iconColor),
    })),
  };
};

const NAMED_COLORS = {
  black: '#000000',
  blue: '#0000ff',
  green: '#008000',
  lightblue: '#add8e6',
  red: '#ff0000',
  white: '#ffffff',
  yellow: '#ffff00',
};

const parseColor = (color) => {
  if (typeof color !== 'string') return null;

  const normalized = NAMED_COLORS[color.toLowerCase()] || color.toLowerCase();
  const hexMatch = normalized.match(/^#([\da-f]{3}|[\da-f]{6}|[\da-f]{8})$/i);
  if (hexMatch) {
    let hex = hexMatch[1];
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((part) => part + part)
        .join('');
    }
    const hasAlpha = hex.length === 8;
    return {
      r: parseInt(hex.slice(0, 2), 16),
      g: parseInt(hex.slice(2, 4), 16),
      b: parseInt(hex.slice(4, 6), 16),
      a: hasAlpha ? parseInt(hex.slice(6, 8), 16) / 255 : 1,
    };
  }

  const rgbMatch = normalized.match(
    /^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*([\d.]+))?\s*\)$/,
  );
  if (!rgbMatch) return null;

  return {
    r: Number(rgbMatch[1]),
    g: Number(rgbMatch[2]),
    b: Number(rgbMatch[3]),
    a: rgbMatch[4] === undefined ? 1 : Number(rgbMatch[4]),
  };
};

const toHex = ({ r, g, b }) =>
  `#${[r, g, b].map((value) => Math.round(value).toString(16).padStart(2, '0')).join('')}`;

const formatColor = (rgb, alpha = 1) =>
  alpha < 1
    ? `rgba(${Math.round(rgb.r)}, ${Math.round(rgb.g)}, ${Math.round(rgb.b)}, ${Number(alpha.toFixed(3))})`
    : toHex(rgb);

const rgbToHsl = ({ r, g, b }) => {
  const red = r / 255;
  const green = g / 255;
  const blue = b / 255;
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  const lightness = (max + min) / 2;
  const delta = max - min;

  if (delta === 0) return { h: 0, s: 0, l: lightness * 100 };

  const saturation = delta / (1 - Math.abs(2 * lightness - 1));
  let hue;
  if (max === red) hue = 60 * (((green - blue) / delta) % 6);
  else if (max === green) hue = 60 * ((blue - red) / delta + 2);
  else hue = 60 * ((red - green) / delta + 4);

  return { h: hue < 0 ? hue + 360 : hue, s: saturation * 100, l: lightness * 100 };
};

const hslToRgb = ({ h, s, l }) => {
  const saturation = s / 100;
  const lightness = l / 100;
  const chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  const hueSegment = h / 60;
  const x = chroma * (1 - Math.abs((hueSegment % 2) - 1));
  const [red, green, blue] =
    hueSegment < 1
      ? [chroma, x, 0]
      : hueSegment < 2
        ? [x, chroma, 0]
        : hueSegment < 3
          ? [0, chroma, x]
          : hueSegment < 4
            ? [0, x, chroma]
            : hueSegment < 5
              ? [x, 0, chroma]
              : [chroma, 0, x];
  const match = lightness - chroma / 2;

  return {
    r: (red + match) * 255,
    g: (green + match) * 255,
    b: (blue + match) * 255,
  };
};

const relativeLuminance = ({ r, g, b }) => {
  const channels = [r, g, b].map((value) => {
    const channel = value / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
};

const contrastRatio = (first, second) => {
  const lighter = Math.max(relativeLuminance(first), relativeLuminance(second));
  const darker = Math.min(relativeLuminance(first), relativeLuminance(second));
  return (lighter + 0.05) / (darker + 0.05);
};

const normalizeSeriesColor = (color, theme, seriesIndex) => {
  const parsed = parseColor(color);
  if (!parsed || parsed.a === 0) return color;

  const background = parseColor(theme.plotBackground);
  if (!background) return color;

  if (theme.monochrome) {
    return theme.seriesPalette[seriesIndex % theme.seriesPalette.length];
  }

  if (theme.preserveAccessibleSeriesColors && contrastRatio(parsed, background) >= 3) {
    return color;
  }

  const hsl = rgbToHsl(parsed);
  const chroma =
    (Math.max(parsed.r, parsed.g, parsed.b) - Math.min(parsed.r, parsed.g, parsed.b)) / 255;
  if (hsl.s < 12 || chroma < 0.12) {
    return theme.seriesPalette[seriesIndex % theme.seriesPalette.length];
  }

  const luminance = relativeLuminance(parsed);
  const contrast = contrastRatio(parsed, background);
  const isComfortable = theme.darkMode
    ? contrast >= 3 && luminance >= 0.16 && luminance <= 0.55 && hsl.s <= 85
    : contrast >= 3 && luminance >= 0.05 && luminance <= 0.5 && hsl.s <= 85;

  if (isComfortable) return color;

  const adjustedHsl = {
    h: hsl.h,
    s: Math.min(78, Math.max(45, hsl.s)),
    l: theme.darkMode ? Math.min(68, Math.max(58, hsl.l)) : Math.min(48, Math.max(32, hsl.l)),
  };
  let adjusted = hslToRgb(adjustedHsl);

  while (contrastRatio(adjusted, background) < 3 && adjustedHsl.l > 20 && adjustedHsl.l < 80) {
    adjustedHsl.l += theme.darkMode ? 3 : -3;
    adjusted = hslToRgb(adjustedHsl);
  }

  return formatColor(adjusted, parsed.a);
};

const styleColorValue = (color, theme, seriesIndex) => {
  if (Array.isArray(color)) {
    return color.map((item) => normalizeSeriesColor(item, theme, seriesIndex));
  }
  return normalizeSeriesColor(color, theme, seriesIndex);
};

const styleSeries = (series, theme) => {
  if (!Array.isArray(series)) return series;

  return series.map((item, seriesIndex) => ({
    ...item,
    itemStyle: item.itemStyle
      ? {
          ...item.itemStyle,
          color: styleColorValue(item.itemStyle.color, theme, seriesIndex),
          borderColor: styleColorValue(item.itemStyle.borderColor, theme, seriesIndex),
        }
      : item.itemStyle,
    lineStyle: item.lineStyle
      ? {
          ...item.lineStyle,
          color: styleColorValue(item.lineStyle.color, theme, seriesIndex),
        }
      : item.lineStyle,
    areaStyle: item.areaStyle
      ? {
          ...item.areaStyle,
          color: styleColorValue(item.areaStyle.color, theme, seriesIndex),
        }
      : item.areaStyle,
    markPoint: styleMarkPoint(item.markPoint, theme),
  }));
};

export const applyChartThemeToOption = (option, chartOptions = DEFAULT_CHART_OPTIONS) => {
  if (!option || typeof option !== 'object') return option;

  const theme = getChartThemeConfig(chartOptions);

  return {
    ...option,
    backgroundColor: theme.plotBackground,
    title: mapStyleObject(option.title, (title) => ({
      ...title,
      textStyle: {
        ...title?.textStyle,
        color: theme.textColor,
      },
    })),
    tooltip: option.tooltip
      ? {
          ...option.tooltip,
          backgroundColor: theme.tooltipBackground,
          borderColor: theme.tooltipBorderColor,
          textStyle: {
            ...option.tooltip.textStyle,
            color: theme.textColor,
          },
        }
      : option.tooltip,
    legend: mapStyleObject(option.legend, (legend) => ({
      ...legend,
      textStyle: {
        ...legend?.textStyle,
        color: theme.textColor,
      },
      pageTextStyle: {
        ...legend?.pageTextStyle,
        color: theme.mutedTextColor,
      },
      pageIconColor: theme.textColor,
      pageIconInactiveColor: theme.axisColor,
    })),
    xAxis: mapAxis(option.xAxis, theme),
    yAxis: mapAxis(option.yAxis, theme),
    dataZoom: Array.isArray(option.dataZoom)
      ? option.dataZoom.map((zoom) => styleDataZoom(zoom, theme))
      : option.dataZoom
        ? styleDataZoom(option.dataZoom, theme)
        : option.dataZoom,
    color: Array.isArray(option.color)
      ? option.color.map((color, index) => normalizeSeriesColor(color, theme, index))
      : option.color,
    series: styleSeries(option.series, theme),
  };
};

export const getChartContainerStyles = (chartOptions = DEFAULT_CHART_OPTIONS) => {
  const theme = getChartThemeConfig(chartOptions);

  return {
    className: theme.containerClassName,
    panelBackground: theme.panelBackground,
    plotBackground: theme.plotBackground,
    textColor: theme.textColor,
  };
};
